// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wallet-clubs-page {
  --wallet-bg-1: #07131b;
  --wallet-bg-2: #0b1d29;
  --wallet-bg-3: #04080c;
  --wallet-emerald: #31e6a4;
  --wallet-gold: #f0ca73;
  --wallet-text: #f5f0e5;
  --wallet-text-soft: rgba(233, 238, 241, 0.7);
  --wallet-panel: rgba(7, 16, 22, 0.96);
  min-height: 100vh;
  min-height: 100dvh;
  padding:
    calc(14px + var(--app-safe-top))
    calc(14px + var(--app-safe-right))
    calc(20px + var(--app-safe-bottom))
    calc(14px + var(--app-safe-left));
  position: relative;
  overflow-x: hidden;
  color: var(--wallet-text);
  background:
    radial-gradient(circle at top center, rgba(53, 109, 92, 0.24) 0%, rgba(7, 19, 27, 0) 34%),
    linear-gradient(180deg, var(--wallet-bg-1) 0%, var(--wallet-bg-2) 52%, var(--wallet-bg-3) 100%);
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Segoe UI', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.wallet-clubs-page::before {
  content: '';
  position: fixed;
  inset: 0;
  pointer-events: none;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.018) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.012) 1px, transparent 1px);
  background-size: 16px 16px;
  opacity: 0.45;
}

.wallet-clubs-page__texture {
  position: fixed;
  inset: 0;
  pointer-events: none;
  background:
    radial-gradient(circle at 10% 15%, rgba(49, 230, 164, 0.08) 0%, transparent 18%),
    radial-gradient(circle at 90% 10%, rgba(240, 202, 115, 0.08) 0%, transparent 16%);
  opacity: 0.8;
}

.wallet-clubs-topbar,
.wallet-clubs-summary,
.wallet-clubs-list {
  position: relative;
  z-index: 1;
}

.wallet-clubs-topbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.wallet-clubs-topbar__title {
  display: grid;
  gap: 4px;
  min-width: 0;
  flex: 1 1 auto;
}

.wallet-clubs-topbar__eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  width: fit-content;
  color: var(--wallet-gold);
  text-transform: uppercase;
  letter-spacing: 0.16em;
  font-size: 0.62rem;
}

.wallet-clubs-topbar__eyebrow svg {
  width: 13px;
  height: 13px;
}

.wallet-clubs-topbar h1 {
  margin: 0;
  font-size: clamp(1.1rem, 3vw, 1.45rem);
  line-height: 1.1;
  letter-spacing: -0.03em;
}

.wallet-clubs-topbar__chip {
  display: inline-flex;
  width: fit-content;
  align-items: center;
  min-height: 24px;
  padding: 0 10px;
  border-radius: 999px;
  color: rgba(245, 240, 229, 0.82);
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.06);
  font-size: 0.76rem;
}

.wallet-clubs-topbar__actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
  flex: 0 0 auto;
  white-space: nowrap;
}

.wallet-clubs-topbar__profile {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  padding: 0 10px 0 0;
}

.wallet-clubs-topbar__avatar {
  width: 30px;
  height: 30px;
  border-radius: 999px;
  overflow: hidden;
  flex: 0 0 auto;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.05);
  box-shadow: 0 10px 18px rgba(0, 0, 0, 0.22);
}

.wallet-clubs-topbar__avatar img,
.wallet-clubs-topbar__avatar span {
  display: block;
  width: 100%;
  height: 100%;
}

.wallet-clubs-topbar__avatar img {
  object-fit: cover;
}

.wallet-clubs-topbar__avatar span {
  display: grid;
  place-items: center;
  font-size: 0.7rem;
  font-weight: 700;
  color: #f5f0e5;
  background: linear-gradient(180deg, rgba(49, 230, 164, 0.35) 0%, rgba(16, 68, 52, 0.9) 100%);
}

.wallet-clubs-topbar__profile strong {
  max-width: 8.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: rgba(245, 240, 229, 0.92);
  font-size: 0.84rem;
  font-weight: 600;
}

.wallet-clubs-topbar__actions button,
.wallet-clubs-card {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  padding: 14px;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(8, 15, 22, 0.92);
  color: var(--wallet-text);
  font-size: 0.84rem;
}

.wallet-clubs-topbar__actions button svg {
  width: 15px;
  height: 15px;
}

.wallet-clubs-topbar__actions button {
  cursor: pointer;
}

.wallet-clubs-summary {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 12px;
}

.wallet-clubs-search {
  margin-bottom: 12px;
}

.wallet-clubs-search__field {
  display: grid;
  gap: 6px;
}

.wallet-clubs-search__field span {
  color: var(--wallet-gold);
  text-transform: uppercase;
  letter-spacing: 0.14em;
  font-size: 0.62rem;
}

.wallet-clubs-search__control {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 46px;
  padding: 0 12px;
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(8, 15, 22, 0.92);
  box-shadow: 0 18px 34px rgba(0, 0, 0, 0.22);
}

.wallet-clubs-search__control svg {
  width: 16px;
  height: 16px;
  color: rgba(233, 238, 241, 0.64);
  flex: 0 0 auto;
}

.wallet-clubs-search__control input {
  width: 100%;
  min-width: 0;
  border: 0;
  background: transparent;
  color: var(--wallet-text);
  font-size: 0.88rem;
}

.wallet-clubs-search__control input::placeholder {
  color: rgba(233, 238, 241, 0.42);
}

.wallet-clubs-search__control input:focus {
  outline: none;
}

.wallet-clubs-search__control button {
  flex: 0 0 auto;
  width: 26px;
  height: 26px;
  border: 0;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.06);
  color: rgba(245, 240, 229, 0.88);
  cursor: pointer;
}

.wallet-clubs-summary__card,
.wallet-clubs-card,
.wallet-clubs-empty {
  padding: 14px;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: linear-gradient(180deg, rgba(14, 24, 31, 0.94) 0%, rgba(8, 15, 22, 0.98) 100%);
  box-shadow: 0 18px 34px rgba(0, 0, 0, 0.28);
}

.wallet-clubs-summary__card span {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: var(--wallet-gold);
  text-transform: uppercase;
  letter-spacing: 0.14em;
  font-size: 0.62rem;
}

.wallet-clubs-summary__card span svg,
.wallet-clubs-card__balance span svg {
  width: 13px;
  height: 13px;
}

.wallet-clubs-summary__card strong {
  display: block;
  margin-top: 8px;
  font-size: clamp(1.05rem, 3vw, 1.4rem);
  line-height: 1.1;
}

.wallet-clubs-summary__card--accent {
  border-color: rgba(49, 230, 164, 0.2);
}

.wallet-clubs-list {
  display: grid;
  gap: 12px;
}

.wallet-clubs-card p,
.wallet-clubs-empty {
  margin: 0;
  color: var(--wallet-text-soft);
  font-size: 0.82rem;
  line-height: 1.45;
}

.wallet-clubs-empty {
  text-align: center;
}

.wallet-clubs-empty--error {
  border-color: rgba(255, 127, 114, 0.18);
  color: #ffd3cc;
}

.wallet-clubs-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
}

.wallet-clubs-card {
  display: grid;
  gap: 10px;
  width: 100%;
  justify-items: stretch;
  cursor: pointer;
  text-decoration: none;
  transition: transform 160ms ease, border-color 160ms ease, background 160ms ease, box-shadow 160ms ease;
}

.wallet-clubs-card:hover,
.wallet-clubs-card:focus-visible {
  transform: translateY(-1px);
  border-color: rgba(49, 230, 164, 0.22);
  background: linear-gradient(180deg, rgba(15, 27, 35, 0.98) 0%, rgba(8, 15, 22, 0.98) 100%);
  box-shadow: 0 22px 38px rgba(0, 0, 0, 0.34);
}

.wallet-clubs-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.wallet-clubs-card__headline {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.wallet-clubs-card__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 9px;
  color: var(--wallet-gold);
  background: rgba(240, 202, 115, 0.08);
  flex: 0 0 auto;
}

.wallet-clubs-card__icon svg {
  width: 14px;
  height: 14px;
}

.wallet-clubs-card__head strong {
  font-size: 0.92rem;
  line-height: 1.2;
}

.wallet-clubs-card__balance {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(49, 230, 164, 0.12);
}

.wallet-clubs-card__balance span {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: rgba(233, 238, 241, 0.74);
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  flex: 0 0 auto;
}

.wallet-clubs-card__divider {
  flex: 1 1 auto;
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.12) 50%, transparent 100%);
}

.wallet-clubs-card__balance strong {
  flex: 0 0 auto;
  font-size: 1.04rem;
  line-height: 1.1;
  text-align: right;
}

@media (max-width: 720px) {
  .wallet-clubs-page {
    padding:
      calc(12px + var(--app-safe-top))
      calc(12px + var(--app-safe-right))
      calc(16px + var(--app-safe-bottom))
      calc(12px + var(--app-safe-left));
  }

  .wallet-clubs-topbar {
    align-items: flex-start;
  }

  .wallet-clubs-topbar__actions {
    justify-content: flex-end;
    gap: 6px;
  }

  .wallet-clubs-topbar__actions button {
    min-height: 38px;
    padding: 0 10px;
    font-size: 0.8rem;
  }

  .wallet-clubs-topbar__actions button svg {
    width: 14px;
    height: 14px;
  }

  .wallet-clubs-summary {
    grid-template-columns: 1fr;
  }

  .wallet-clubs-grid {
    grid-template-columns: 1fr;
  }

  .wallet-clubs-search__control {
    min-height: 44px;
  }

  .wallet-clubs-topbar__profile {
    max-width: calc(100vw - 150px);
    padding-right: 6px;
  }

  .wallet-clubs-topbar__profile strong {
    max-width: 6.8rem;
    font-size: 0.8rem;
  }

  .wallet-clubs-card__balance {
    gap: 8px;
  }

  .wallet-clubs-card__balance strong {
    font-size: 0.98rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/WalletClubsPage.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,4CAA4C;EAC5C,qCAAqC;EACrC,iBAAiB;EACjB,kBAAkB;EAClB;;;;qCAImC;EACnC,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB;;mGAEiG;EACjG,wFAAwF;EACxF,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR,oBAAoB;EACpB;;2EAEyE;EACzE,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,oBAAoB;EACpB;;qFAEmF;EACnF,YAAY;AACd;;AAEA;;;EAGE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,sCAAsC;EACtC,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gCAAgC;EAChC,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,2CAA2C;EAC3C,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,4FAA4F;AAC9F;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,iCAAiC;EACjC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,2CAA2C;EAC3C,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,eAAe;AACjB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,0FAA0F;EAC1F,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,qBAAqB;EACrB,uGAAuG;AACzG;;AAEA;;EAEE,2BAA2B;EAC3B,sCAAsC;EACtC,0FAA0F;EAC1F,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mGAAmG;AACrG;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE;;;;uCAImC;EACrC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;IACzB,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;IAC9B,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".wallet-clubs-page {\n  --wallet-bg-1: #07131b;\n  --wallet-bg-2: #0b1d29;\n  --wallet-bg-3: #04080c;\n  --wallet-emerald: #31e6a4;\n  --wallet-gold: #f0ca73;\n  --wallet-text: #f5f0e5;\n  --wallet-text-soft: rgba(233, 238, 241, 0.7);\n  --wallet-panel: rgba(7, 16, 22, 0.96);\n  min-height: 100vh;\n  min-height: 100dvh;\n  padding:\n    calc(14px + var(--app-safe-top))\n    calc(14px + var(--app-safe-right))\n    calc(20px + var(--app-safe-bottom))\n    calc(14px + var(--app-safe-left));\n  position: relative;\n  overflow-x: hidden;\n  color: var(--wallet-text);\n  background:\n    radial-gradient(circle at top center, rgba(53, 109, 92, 0.24) 0%, rgba(7, 19, 27, 0) 34%),\n    linear-gradient(180deg, var(--wallet-bg-1) 0%, var(--wallet-bg-2) 52%, var(--wallet-bg-3) 100%);\n  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Segoe UI', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.wallet-clubs-page::before {\n  content: '';\n  position: fixed;\n  inset: 0;\n  pointer-events: none;\n  background-image:\n    linear-gradient(rgba(255, 255, 255, 0.018) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(255, 255, 255, 0.012) 1px, transparent 1px);\n  background-size: 16px 16px;\n  opacity: 0.45;\n}\n\n.wallet-clubs-page__texture {\n  position: fixed;\n  inset: 0;\n  pointer-events: none;\n  background:\n    radial-gradient(circle at 10% 15%, rgba(49, 230, 164, 0.08) 0%, transparent 18%),\n    radial-gradient(circle at 90% 10%, rgba(240, 202, 115, 0.08) 0%, transparent 16%);\n  opacity: 0.8;\n}\n\n.wallet-clubs-topbar,\n.wallet-clubs-summary,\n.wallet-clubs-list {\n  position: relative;\n  z-index: 1;\n}\n\n.wallet-clubs-topbar {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 14px;\n}\n\n.wallet-clubs-topbar__title {\n  display: grid;\n  gap: 4px;\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.wallet-clubs-topbar__eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  width: fit-content;\n  color: var(--wallet-gold);\n  text-transform: uppercase;\n  letter-spacing: 0.16em;\n  font-size: 0.62rem;\n}\n\n.wallet-clubs-topbar__eyebrow svg {\n  width: 13px;\n  height: 13px;\n}\n\n.wallet-clubs-topbar h1 {\n  margin: 0;\n  font-size: clamp(1.1rem, 3vw, 1.45rem);\n  line-height: 1.1;\n  letter-spacing: -0.03em;\n}\n\n.wallet-clubs-topbar__chip {\n  display: inline-flex;\n  width: fit-content;\n  align-items: center;\n  min-height: 24px;\n  padding: 0 10px;\n  border-radius: 999px;\n  color: rgba(245, 240, 229, 0.82);\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  font-size: 0.76rem;\n}\n\n.wallet-clubs-topbar__actions {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  flex: 0 0 auto;\n  white-space: nowrap;\n}\n\n.wallet-clubs-topbar__profile {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  padding: 0 10px 0 0;\n}\n\n.wallet-clubs-topbar__avatar {\n  width: 30px;\n  height: 30px;\n  border-radius: 999px;\n  overflow: hidden;\n  flex: 0 0 auto;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(255, 255, 255, 0.05);\n  box-shadow: 0 10px 18px rgba(0, 0, 0, 0.22);\n}\n\n.wallet-clubs-topbar__avatar img,\n.wallet-clubs-topbar__avatar span {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.wallet-clubs-topbar__avatar img {\n  object-fit: cover;\n}\n\n.wallet-clubs-topbar__avatar span {\n  display: grid;\n  place-items: center;\n  font-size: 0.7rem;\n  font-weight: 700;\n  color: #f5f0e5;\n  background: linear-gradient(180deg, rgba(49, 230, 164, 0.35) 0%, rgba(16, 68, 52, 0.9) 100%);\n}\n\n.wallet-clubs-topbar__profile strong {\n  max-width: 8.5rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: rgba(245, 240, 229, 0.92);\n  font-size: 0.84rem;\n  font-weight: 600;\n}\n\n.wallet-clubs-topbar__actions button,\n.wallet-clubs-card {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 40px;\n  padding: 14px;\n  border-radius: 18px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(8, 15, 22, 0.92);\n  color: var(--wallet-text);\n  font-size: 0.84rem;\n}\n\n.wallet-clubs-topbar__actions button svg {\n  width: 15px;\n  height: 15px;\n}\n\n.wallet-clubs-topbar__actions button {\n  cursor: pointer;\n}\n\n.wallet-clubs-summary {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.wallet-clubs-search {\n  margin-bottom: 12px;\n}\n\n.wallet-clubs-search__field {\n  display: grid;\n  gap: 6px;\n}\n\n.wallet-clubs-search__field span {\n  color: var(--wallet-gold);\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  font-size: 0.62rem;\n}\n\n.wallet-clubs-search__control {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 46px;\n  padding: 0 12px;\n  border-radius: 14px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(8, 15, 22, 0.92);\n  box-shadow: 0 18px 34px rgba(0, 0, 0, 0.22);\n}\n\n.wallet-clubs-search__control svg {\n  width: 16px;\n  height: 16px;\n  color: rgba(233, 238, 241, 0.64);\n  flex: 0 0 auto;\n}\n\n.wallet-clubs-search__control input {\n  width: 100%;\n  min-width: 0;\n  border: 0;\n  background: transparent;\n  color: var(--wallet-text);\n  font-size: 0.88rem;\n}\n\n.wallet-clubs-search__control input::placeholder {\n  color: rgba(233, 238, 241, 0.42);\n}\n\n.wallet-clubs-search__control input:focus {\n  outline: none;\n}\n\n.wallet-clubs-search__control button {\n  flex: 0 0 auto;\n  width: 26px;\n  height: 26px;\n  border: 0;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.06);\n  color: rgba(245, 240, 229, 0.88);\n  cursor: pointer;\n}\n\n.wallet-clubs-summary__card,\n.wallet-clubs-card,\n.wallet-clubs-empty {\n  padding: 14px;\n  border-radius: 18px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: linear-gradient(180deg, rgba(14, 24, 31, 0.94) 0%, rgba(8, 15, 22, 0.98) 100%);\n  box-shadow: 0 18px 34px rgba(0, 0, 0, 0.28);\n}\n\n.wallet-clubs-summary__card span {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  color: var(--wallet-gold);\n  text-transform: uppercase;\n  letter-spacing: 0.14em;\n  font-size: 0.62rem;\n}\n\n.wallet-clubs-summary__card span svg,\n.wallet-clubs-card__balance span svg {\n  width: 13px;\n  height: 13px;\n}\n\n.wallet-clubs-summary__card strong {\n  display: block;\n  margin-top: 8px;\n  font-size: clamp(1.05rem, 3vw, 1.4rem);\n  line-height: 1.1;\n}\n\n.wallet-clubs-summary__card--accent {\n  border-color: rgba(49, 230, 164, 0.2);\n}\n\n.wallet-clubs-list {\n  display: grid;\n  gap: 12px;\n}\n\n.wallet-clubs-card p,\n.wallet-clubs-empty {\n  margin: 0;\n  color: var(--wallet-text-soft);\n  font-size: 0.82rem;\n  line-height: 1.45;\n}\n\n.wallet-clubs-empty {\n  text-align: center;\n}\n\n.wallet-clubs-empty--error {\n  border-color: rgba(255, 127, 114, 0.18);\n  color: #ffd3cc;\n}\n\n.wallet-clubs-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 12px;\n}\n\n.wallet-clubs-card {\n  display: grid;\n  gap: 10px;\n  width: 100%;\n  justify-items: stretch;\n  cursor: pointer;\n  text-decoration: none;\n  transition: transform 160ms ease, border-color 160ms ease, background 160ms ease, box-shadow 160ms ease;\n}\n\n.wallet-clubs-card:hover,\n.wallet-clubs-card:focus-visible {\n  transform: translateY(-1px);\n  border-color: rgba(49, 230, 164, 0.22);\n  background: linear-gradient(180deg, rgba(15, 27, 35, 0.98) 0%, rgba(8, 15, 22, 0.98) 100%);\n  box-shadow: 0 22px 38px rgba(0, 0, 0, 0.34);\n}\n\n.wallet-clubs-card__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.wallet-clubs-card__headline {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.wallet-clubs-card__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 26px;\n  height: 26px;\n  border-radius: 9px;\n  color: var(--wallet-gold);\n  background: rgba(240, 202, 115, 0.08);\n  flex: 0 0 auto;\n}\n\n.wallet-clubs-card__icon svg {\n  width: 14px;\n  height: 14px;\n}\n\n.wallet-clubs-card__head strong {\n  font-size: 0.92rem;\n  line-height: 1.2;\n}\n\n.wallet-clubs-card__balance {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.02);\n  border: 1px solid rgba(49, 230, 164, 0.12);\n}\n\n.wallet-clubs-card__balance span {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  color: rgba(233, 238, 241, 0.74);\n  font-size: 0.68rem;\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  flex: 0 0 auto;\n}\n\n.wallet-clubs-card__divider {\n  flex: 1 1 auto;\n  height: 1px;\n  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.12) 50%, transparent 100%);\n}\n\n.wallet-clubs-card__balance strong {\n  flex: 0 0 auto;\n  font-size: 1.04rem;\n  line-height: 1.1;\n  text-align: right;\n}\n\n@media (max-width: 720px) {\n  .wallet-clubs-page {\n    padding:\n      calc(12px + var(--app-safe-top))\n      calc(12px + var(--app-safe-right))\n      calc(16px + var(--app-safe-bottom))\n      calc(12px + var(--app-safe-left));\n  }\n\n  .wallet-clubs-topbar {\n    align-items: flex-start;\n  }\n\n  .wallet-clubs-topbar__actions {\n    justify-content: flex-end;\n    gap: 6px;\n  }\n\n  .wallet-clubs-topbar__actions button {\n    min-height: 38px;\n    padding: 0 10px;\n    font-size: 0.8rem;\n  }\n\n  .wallet-clubs-topbar__actions button svg {\n    width: 14px;\n    height: 14px;\n  }\n\n  .wallet-clubs-summary {\n    grid-template-columns: 1fr;\n  }\n\n  .wallet-clubs-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .wallet-clubs-search__control {\n    min-height: 44px;\n  }\n\n  .wallet-clubs-topbar__profile {\n    max-width: calc(100vw - 150px);\n    padding-right: 6px;\n  }\n\n  .wallet-clubs-topbar__profile strong {\n    max-width: 6.8rem;\n    font-size: 0.8rem;\n  }\n\n  .wallet-clubs-card__balance {\n    gap: 8px;\n  }\n\n  .wallet-clubs-card__balance strong {\n    font-size: 0.98rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
